import React, { useState } from 'react';
import './china.css';

const China = () => {
  const [isVisible, setIsVisible] = useState(false);

  const handleMouseOver = () => {
    setIsVisible(true);
  };

  const handleMouseOut = () => {
    setIsVisible(false);
  };

  return (
    <>
      <div
        className="china"
        onMouseOver={handleMouseOver}
        onMouseOut={handleMouseOut}
      ></div>
      <div className="contact-item-china">
        <div className={`content ${isVisible ? 'd-flex' : 'd-none'}`}>
          <div className="item">
            <p>Hong Kong, China</p>
          </div>
          <img
            src={`${process.env.PUBLIC_URL}/images/bottom.svg`}
            alt="arrow bottom"
            className="arrow-down"
          />
        </div>
      </div>
    </>
  );
};

export default China;
